import { render, staticRenderFns } from "./rnav.vue?vue&type=template&id=15fbb528&scoped=true&"
import script from "./rnav.vue?vue&type=script&lang=js&"
export * from "./rnav.vue?vue&type=script&lang=js&"
import style0 from "./rnav.vue?vue&type=style&index=0&id=15fbb528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbb528",
  null
  
)

export default component.exports